import styled from "styled-components";

export const VideoSlideFooterRightContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 40px;
    justify-content: flex-end;
    align-items: center;
    -webkit-tap-highlight-color: transparent;
`;